import { Route } from '@angular/router';
import { AppUrls } from '../../../../../../common/dto/app-urls';

export const TrendsRoute: Route = {
  path: AppUrls.Dashboard._.Discover._.Trends.relativeUrl,
  loadComponent: () => import('./trends.component').then(_ => _.TrendsComponent),
};
